import { FilterRailManifest } from './filter-manifest.types';
import { SURR_YEARS_LABELS } from '../models/product-search.models';

/**
 * Architectural prototype (2026-06-11) — the /products Advanced-filters tree
 * expressed as data. This 30-line manifest replaces the ~70 lines of
 * hand-written group/picker HTML in product-search-rail.component.html.
 *
 * Field keys map to ProductFilterSlot; optionsKey maps to the host's
 * options(key) (→ filterState.filterOptions()[key]). The carrier fly-out and
 * the Status toggle are 'slot' dims projected by the host so the prototype
 * doesn't re-plumb them.
 *
 * Mirrors the rates Advanced-filters group order/names; the rate-only
 * "Crediting Strategy" group is absent by design (no products equivalent).
 */
export const PRODUCTS_FILTER_MANIFEST: FilterRailManifest = {
  surface: 'products',
  groups: [
    {
      id: 'company',
      label: 'Company & Product',
      dims: [
        { id: 'carrier',     label: 'Carriers',     kind: 'slot',      slot: 'carrier' },
        { id: 'premiumType', label: 'Premium Type', kind: 'checklist', field: 'selectedPremiumTypes', optionsKey: 'premiumType' },
        { id: 'amBest',      label: 'A.M. Best',    kind: 'checklist', field: 'selectedAmBest',      optionsKey: 'amBest' },
        { id: 'shareClass',  label: 'Share Class',  kind: 'checklist', field: 'selectedShareClasses', optionsKey: 'shareClass' },
        { id: 'status',      label: 'Status',       kind: 'slot',      slot: 'status' },
      ],
    },
    {
      id: 'surrender',
      label: 'Surrenders & Premium',
      dims: [
        { id: 'surrYears',  label: 'Surrender Years',  kind: 'checklist', field: 'selectedSurrYears', optionsKey: 'surrYears', labelMap: SURR_YEARS_LABELS },
        { id: 'premium',    label: 'Premium',          kind: 'premium',   field: 'selectedPremium' },
      ],
    },
    {
      id: 'riders',
      label: 'Riders',
      dims: [
        { id: 'riders', label: 'Riders', kind: 'checklist', field: 'selectedRiders', optionsKey: 'riders' },
      ],
    },
    {
      id: 'states',
      label: 'State Availability',
      dims: [
        { id: 'state', label: 'State', kind: 'checklist', field: 'selectedStates', optionsKey: 'state' },
      ],
    },
  ],
};
